export const environment = {
  baseUrl: 'https://uxcomic.github.io',
  cdnUrl: 'https://cdn.jsdelivr.net/gh/UXcomic/UXcomic.github.io@gh-pages',
  aboutPostId: '10f5d164-78d8-804f-b8ea-e2a265424273',
  cloudinaryCloudName: 'dpzknshvi',
  defaultCategory: 'cheat-sheet',
  defaultTag: 'design',
  prefixOGTitle: 'UX share chơi 😄',
}
